import React from 'react';
import { FieldValues, Path } from 'react-hook-form';
import { useFormType, TypedInputProps } from './ZodFormProvider';
import CustomSelect from '../../SelectField';

// Extending the CustomSelect props but making name type-safe
interface ZodSelectComponentProps<T extends FieldValues> extends Omit<React.ComponentProps<typeof CustomSelect>, 'name'>, TypedInputProps<T> {
    // No additional props needed, we're just constraining 'name'
}

// Generic component that enforces type safety for field names
function ZodSelect<T extends FieldValues = FieldValues>({
    name,
    ...rest
}: ZodSelectComponentProps<T>) {
    // This is only used to infer the type, it doesn't actually use the context value
    useFormType<T>();

    return <CustomSelect name={name} {...rest} />;
}

// Helper function to create a typed select for a specific form type
export function createZodSelect<T extends FieldValues>() {
    return function TypedSelectWithGeneric(props: ZodSelectComponentProps<T>) {
        return <ZodSelect<T> {...props} />;
    };
}

export default ZodSelect;